import { createSelector } from 'reselect';
import { getSelectedNotification } from '../../../../../../PowertrainOverview/Header/NotificationDropdown/selectors';
import UserCapabilityHelper from 'helpers/userCapabilityHelper';
import { TIME_SERIES_CATEGORY } from '../../../CommonCharts/Trend/constants';

const getUserCapabilities = ({ overview }) => overview?.userCapabilities;

const getIsOperationalParametersEnergyCapabilityEnabled = createSelector([
    getUserCapabilities
], (capability) => {
    const userCapabilityHelper = new UserCapabilityHelper(capability);
    return userCapabilityHelper.hasOperationalParametersEnergyCapability();
});

export const getTrendKPIsList = createSelector([
    ({ operationalParameters }) => operationalParameters?.availableKPIs?.trend?.data,
    getIsOperationalParametersEnergyCapabilityEnabled
], (
    trendKPIs,
    isOperationalParametersEnergyCapabilityEnabled,
) => {
    const mergedTrendKpiList = [];
    trendKPIs?.forEach((kpi) => {
        const kpiObj = kpi?.data;
        if (!kpiObj) { return; }
        const keys = Object.keys(kpiObj);
        keys?.forEach(key => {
            const newObj = kpiObj[key];
            if (!isOperationalParametersEnergyCapabilityEnabled) {
                mergedTrendKpiList.push(newObj);
                return;
            }
            // Filter for operational parameters based on timeseriesCategory field from API
            const isOperationalByCategory = newObj.timeseriesCategory === TIME_SERIES_CATEGORY.OPERATIONAL || newObj?.timeseriesCategory === TIME_SERIES_CATEGORY.ENERGY_OPERATIONAL;
            if (isOperationalByCategory) {
                mergedTrendKpiList.push(newObj);
            }
        });
    });
    return mergedTrendKpiList;
});

const getSelectedTrendKPIs = ({ operationalParameters }) => {
    return operationalParameters?.preselectedKPIs?.single?.trend;
};

const getSelectedTrendsData = ({ operationalParameters }) => {
    return operationalParameters?.charts?.single?.trend[0]?.kpiList;
};

const getSelectedAsset = ({ powertrainAssetDetails }) => {
    return powertrainAssetDetails?.selectedAsset;
};

const getDateSelection = ({ overview }) => {
    return overview?.dateSelection;
};

export const getModel = createSelector([
    getTrendKPIsList,
    getSelectedTrendsData,
    getSelectedTrendKPIs,
    getSelectedAsset,
    getDateSelection,
    getSelectedNotification
], (
    trendKPIsList,
    selectedTrendsData,
    selectedTrendKPIs,
    selectedAsset,
    dateSelection,
    selectedNotification
) => {
    return {
        trendKPIsList,
        selectedTrendsData,
        selectedTrendKPIs,
        selectedAsset,
        dateSelection,
        selectedNotification
    };
});
